export class TextGrow {


    /**
     * Contains the text area element.
     *
     * @private
     * @type {HTMLTextAreaElement}
     * @memberof TextGrow
     */
    private field: JQuery;


    /**
     * Creates an instance of TextGrow.
     *
     * @param {HTMLTextAreaElement} field
     * @memberof TextGrow
     */
    constructor(field: JQuery) {
        this.field = field;

        this.addListeners();
    }


    /**
     * Add's the event listeners for this component.
     *
     * @private
     * @memberof TextGrow
     */
    private addListeners() {

        this.field.on('input', () => {
            this.setHeight();
        });
    }


    /**
     * Sets the height of the textarea field.
     *
     * @private
     * @memberof TextGrow
     */
    private setHeight() {
        const field = this.field.get(0);
        field.style.cssText = 'height: auto';
        field.style.cssText = `height: ${field.scrollHeight}px`;
    }
}
